import React from 'react';
import { Button, Col, Divider, Flex, Input, List, Skeleton, Space, Row } from 'antd';
import { useAuth } from "../../auth/authcontext";

interface AddOnGroup {
  guid: string;
  name: string;
}

interface AddOnGroupListProps {
  isLoadingAddOnGroups: boolean;
  menuAddOnGroups: AddOnGroup[];
  filterText: string;
  onResetAddOnProperties: () => void;
  onClickLoadMoag: (guid: string) => void;
  onFilterAddOnGroupList: (e: React.ChangeEvent<HTMLInputElement>) => void;
}

const AddOnGroupList: React.FC<AddOnGroupListProps> = ({
  isLoadingAddOnGroups,
  menuAddOnGroups,
  filterText,
  onResetAddOnProperties,
  onClickLoadMoag,
  onFilterAddOnGroupList,
}) => {
  const { isReadOnly } = useAuth();
  return (
    <Row>
      <Col span={2}></Col>
      <Col span={20}>
        <Flex style={{ paddingTop: 20 }} vertical>
          <Space direction="vertical">
            <Row>
              <Col span={20} offset={2}>
                <h4>Add-On Groups</h4>
              </Col>
            </Row>

              <Button
                color="green"
                variant="solid"
                size="small"
                style={{ width: '100%' }}
                onClick={onResetAddOnProperties}
              >
                New Add-On Group
              </Button>
          </Space>
        </Flex>

        <Divider />
        <Flex vertical>
          {isLoadingAddOnGroups ? <Skeleton active /> : null}
          <Space direction="vertical">
            <Input
              value={filterText}
              onChange={onFilterAddOnGroupList}
              placeholder="Filter Groups"
              allowClear
            />
            {menuAddOnGroups && (
              <List
                style={{ backgroundColor: '#ededed', marginBottom: '8px', }}
                bordered
                dataSource={menuAddOnGroups}
                renderItem={(item) => (
                  <List.Item key={item.guid} onClick={() => onClickLoadMoag(item.guid)}>
                    {item.name}
                  </List.Item>
                )}
              />
            )}
          </Space>
        </Flex>
      </Col>
      <Col span={2}></Col>
    </Row>
  );
};

export default AddOnGroupList;